<template>
    <v-container>
            <h1 class='mb-3'>Create your Store </h1>
            <v-stepper v-model="e1">
                <v-stepper-header>
                    <v-stepper-step :editable="editable[0]" :complete="e1 > 1" step="1">Name your Store</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step :editable="editable[1]" :complete="e1 > 2" step="2">Address of the Store</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step :editable="editable[2]" :complete="e1 > 3" step="3">Add Store Logo</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step :editable="editable[3]" :complete="e1 > 4" step="4">Add Store Banner Image</v-stepper-step>
                </v-stepper-header>
                <v-stepper-items>
                    <v-stepper-content elevation="0" step="1">
                        <div>
                            <v-row class='justify-center'>
                                <v-col lg=6>
                                    <h3 class='text-center'>Enter basic details of your store</h3>
                                    <v-row justify='center'>
                                            <v-form class='col-10 mt-5' ref="form1">
                                            
                                                        <v-text-field :rules="[rules.required]" outlined v-model="name" dense label='Name of your Store'></v-text-field>
                                                        <v-text-field :rules="[rules.required]" outlined v-model="type" dense label='Type of your Store'></v-text-field>
                                                
                                                <v-row justify='center'>
                                                    <v-btn :loading="loader" :disabled="loader" class="white--text" color='#ff676e' @click="saveBasicDetails">
                                                        Next 
                                                        <v-icon right>
                                                            mdi-arrow-right
                                                        </v-icon>
                                                    </v-btn>
                                                </v-row>

                                            </v-form>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </div>
                    </v-stepper-content>
                    <v-stepper-content step="2">
                        <div>
                            <v-row class='justify-center'>
                                <v-col lg=6>
                                <h3 class='text-center'>Enter address of your store</h3>
                                <v-row justify="center">
                                <v-form class='col-10 mt-5' ref="form2">
                                    <v-text-field :rules="[rules.required]" outlined v-model="address1" dense label='Address line 1'></v-text-field>
                                    <v-text-field outlined v-model="address2" dense label='Address Line 2'></v-text-field>
                                    <v-text-field :rules="[rules.required]" outlined v-model="city" dense label='City'></v-text-field>
                                    <v-text-field :rules="[rules.required]" outlined v-model="state" dense label='State'></v-text-field>
                                    <v-text-field :rules="[rules.required]" outlined v-model="pincode" dense label='Pincode'></v-text-field>
                                    <v-row class='justify-center'>
                                        <v-btn :loading="loader" :disabled="loader" class="white--text" color='#ff676e' @click="saveAddress">
                                            Next 
                                            <v-icon right>
                                                mdi-arrow-right
                                            </v-icon>
                                        </v-btn>
                                    </v-row>

                                </v-form>
                                </v-row>
                                </v-col>
                            </v-row>
                        </div>
                    </v-stepper-content>
                    <v-stepper-content step="3">
                        <div>
                            <h3 class='text-center mb-10'>Upload your store logo</h3>
                            <v-row justify="center">
                             
                                    <ImageUpload v-model="logo" @onFileChange="changeLogo"/>
                            </v-row>
                            
                        </div>
                    </v-stepper-content>
                    <v-stepper-content step="4">
                        <div>
                            <h3 class='text-center mb-10'>Upload your store banner</h3>
                            <v-row justify="center">
                                <ImageUpload v-model="banner" @onFileChange="changeBanner"/>
                            </v-row>
                            
                        </div>
                    </v-stepper-content>
                    
                </v-stepper-items>
            </v-stepper>
    </v-container>
</template>
<script>

/*global myBaseURL*/

import axios from 'axios';
import ImageUpload from '@/components/ImageUpload.vue'
export default {
    name:'AddStore',
    components:{
        ImageUpload
    },
    data() {
        return {
            name: '',
            type: '',
            address1: '',
            address2: '',
            city: '',
            state: '',
            pincode: '',
            logo: '',
            banner: '',
            slug : '',
            editable:[false,false,false,false],
            loader: false,
            e1 : 1,
            showLogoPreview : true,
            profileLink : '',
            rules:{
                required: value => !!value || 'Required.',
                counter: value => value.length <= 25 || 'Max 25 characters',
            }
        }
    },
     created(){
         this.$emit('showNavDrawer',false);
     },
    methods: ({
        saveBasicDetails(){
            var that = this;
            this.loader = true;
            console.log('basics');
            if(this.$refs.form1.validate())
            {
                var formData = new FormData();
                formData.append('name',that.name);
                formData.append('type',that.type);
                formData.append('step',1);

                axios.post( myBaseURL + '/store/create',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': 'Bearer '+ window.localStorage.access_token
                        }
                    }
                ).then(response => {
                    console.log(response.data);
                    that.editable[0]=true;
                    that.slug = response.data.store_slug;
                    that.e1=2;
                    that.loader = false;
                    console.log('Submit Success')
                }).catch(e => {
                    console.log(e);
                    console.log('Submit Fail')
                });
            }
        },
        saveAddress(){
            var that = this;
            this.loader = true;
            console.log('address');
            if(this.$refs.form2.validate() && this.slug != '')
            {
                var formData = new FormData();
                formData.append('slug',that.slug);
                formData.append('address1',that.address1);
                formData.append('address2',that.address2);
                formData.append('city',that.city);
                formData.append('state',that.state);
                formData.append('pincode',that.pincode);
                formData.append('step',2);

                axios.post( myBaseURL + '/store/create',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': 'Bearer '+ window.localStorage.access_token
                        }
                    }
                ).then(response => {
                    console.log(response.data);
                    that.editable[1]=true;
                    that.e1=3;
                    that.loader = false;
                    console.log('Submit Success')
                }).catch(e => {
                    console.log(e);
                    console.log('Submit Fail')
                });
            }
            
        },
        changeLogo(data){
            var that = this;
            this.logo = data;
            if(this.logo && this.logo != '' && this.slug != '')
            {
                var formData = new FormData();
                formData.append('slug',that.slug);
                formData.append('logo',that.logo);
                formData.append('step',3);

                axios.post( myBaseURL + '/store/create',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': 'Bearer '+ window.localStorage.access_token
                        }
                    }
                ).then(response => {
                    console.log(response.data);
                    that.editable[2]=true;
                    that.e1 = 4;
                    console.log('Submit Success')
                }).catch(e => {
                    console.log(e);
                    console.log('Submit Fail')
                });
            }
            
        },
        changeBanner(data){
            var that = this;
            this.banner = data;
            if(this.banner && this.banner != '' && this.slug != '')
            {
                var formData = new FormData();
                formData.append('slug',that.slug);
                formData.append('banner',that.banner);
                formData.append('step',4);

                axios.post( myBaseURL + '/store/create',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': 'Bearer '+ window.localStorage.access_token
                        }
                    }
                ).then(response => {
                    console.log(response.data);
                    that.$router.push({ name: 'Catalogue', params : {store_slug : response.data.store_slug} })
                    console.log('Submit Success')
                }).catch(e => {
                    console.log(e);
                    console.log('Submit Fail')
                });
            }
        },
        addStore(){

        }
    })
}
</script>